import { Component, OnInit } from '@angular/core';
import { MatDialogRef } from '@angular/material';

@Component({
  selector: 'kt-welcome',
  templateUrl: './welcome.component.html',
  styleUrls: ['./welcome.component.css']
})
export class WelcomeComponent implements OnInit {

  constructor(private dialogRef: MatDialogRef<WelcomeComponent>,) { }

  ngOnInit() {
  }

  public dismiss(type) {
    this.dialogRef.close(type);
  }

}
